const ellipsis = {
    maxWidth: '320px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Colunas para listagem de motoristas no modal (alinhado a FindEmployeeData mínimo: id, nome). */
export const DELIVERY_DRIVER_LIST_COLUMNS = [
    {
        header: 'ID',
        accessor: 'id',
        sortable: false,
        render: (item) => (item?.id != null ? String(item.id) : '—'),
    },
    {
        header: 'Nome',
        accessor: 'name',
        sortable: false,
        render: (item) => (
            <div style={ellipsis} title={item?.name || undefined}>
                {item?.name || '—'}
            </div>
        ),
    },
];
